import { fg } from '@atlassian/jira-feature-gating';

const JivColouredDueDateUiChangesRelayprovider = {
	get(): boolean {
		return fg('jiv-coloured-due-date-ui-changes');
	},
};

export default JivColouredDueDateUiChangesRelayprovider;
